import { WorkspaceAction } from "@common/userWorkspaceRoles";
import { useCanPerformWorkspaceAction } from "@hooks/permissions/useCanPerformWorkspaceAction";
import { TaskGroupsPage } from "./TaskGroupsPage";
import { WorkspaceTaskGroupsList } from "./WorkspaceTaskGroupsList";

export const WorkspaceTaskGroups = () => {
    const canManageTaskGroups = useCanPerformWorkspaceAction(
        WorkspaceAction.WORKSPACE_SETTINGS_EDIT,
    );

    return (
        <TaskGroupsPage
            canManageTaskGroups={canManageTaskGroups}
            scope="workspace"
        >
            {(props) => <WorkspaceTaskGroupsList {...props} />}
        </TaskGroupsPage>
    );
};
